// consts for CommonInsurance component
export const INSURANCE = {
  MMB: "mmb",
  RESERVATION: "reservation",
} as const

/** Value for source param in globals tracking, needed for analytics. Do not change the value. */
export const MMB_SOURCE = "mmb"

/** Value for `companyName` placeholder in tkeys mentioning Kiwi.com company. */
export const COMPANY_NAME = "Kiwi.com"
